export default __webpack_public_path__ + "media/images/head2right__1_-e378be830e37e746fe1b247a9cedab69.png";